import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function clevertapTracker(event, data) {
  pushClevertapEvent(event, data);
}
